import React from "react"

import SEO from "~/components/common/Seo"
import Layout from "~/components/common/Layout"
import ResourcesSection from "~/components/index/ResourceSection"
import HeroSection from "~/components/index/HeroSection"
import CampaignInfoSection from "~/components/index/CampaignInfoSection"
import AboutSection from "~/components/index/AboutSection"
import TwitterFeedSection from "~/components/index/TwitterFeedSection"

import "react-sharingbuttons/dist/main.css"
import "pure-react-carousel/dist/react-carousel.es.css"
import "video-react/dist/video-react.css"

import "~/css/style.css"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <HeroSection />
    <CampaignInfoSection />
    <TwitterFeedSection />
    <ResourcesSection />
    <AboutSection />
  </Layout>
)

export default IndexPage
